import {useEffect, useState} from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure
} from "@chakra-ui/react";
import Scanner from 'qr-scanner'

export default function QrScanner({setCode, result}) {
  const {isOpen, onOpen, onClose} = useDisclosure()
  const [videoRef, setVideoRef] = useState(null)

  useEffect(() => {

    if (videoRef) {
      const qrScanner = new Scanner(
        videoRef,
        result => {
          if (!result) return
          const regexList = [
            /pin=(?<pin>\d+)/,
            /code=(?<pin>\w+)/
          ]
          for (const regex of regexList) {
            const re = regex.exec(result.data)
            if (re) {
              setCode(re.groups.pin)
              return onClose()
            }
          }
        },
        {highlightScanRegion: true, highlightCodeOutline: true},
      );

      qrScanner.start();
      return () => {
        qrScanner.stop()
      }
    }
  }, [videoRef]);

  if (result?.success) return null
  if (isOpen) {
    return (
      <Modal isOpen={isOpen} onClose={onClose} size={'full'}>
        <ModalOverlay/>
        <ModalContent>
          <ModalHeader>Escanea el código en tu pantalla</ModalHeader>
          <ModalCloseButton/>
          <ModalBody>
            <video ref={(val) => {
              setVideoRef(val)
            }}></video>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onClose}>
              Cerrar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    )
  }
  return <Button mb={3} onClick={onOpen}>Escanear código QR</Button>

}
